import { render, staticRenderFns } from "./SettingsSquads.vue?vue&type=template&id=67af9ede&"
import script from "./SettingsSquads.vue?vue&type=script&lang=js&"
export * from "./SettingsSquads.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSquads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports